var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseThincomponent = function SvgCloseThincomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21 .059 1.414 1.414-19.8 19.8-1.413-1.415z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m22 19.858-1.414 1.414L.787 1.472 2.201.06z"
  })));
};
export default SvgCloseThincomponent;